module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "rt-defaultImage",
    class: _vm.onClass
  }, [(!_vm.text) ? _c('div', {
    staticClass: "image-content",
    class: _vm.classes
  }, [(!_vm.textOnly) ? _vm._t("default", function() {
    return [_c('rt-icon', {
      attrs: {
        "size": _vm.iconSize,
        "name": _vm.iconName
      }
    })]
  }) : _vm._e()], 2) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "describe",
    class: {
      'is-text': _vm.text
    }
  }, [_vm._t("describe", function() {
    return [_vm._v("\n      " + _vm._s(_vm.$tx('暂无数据', 'xpc.defaultImage.noData')) + "\n    ")]
  })], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5e458eda"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/vue-xpc/src/components/defaultImage/rtDefaultImage.vue
// module id = 2156
// module chunks = 137